/** @jsx jsx */

import React, {
  memo,
  useMemo,
  useState,
  useContext,
  useRef,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import EditMarker from 'components/UI/EditMarker';
import { colors } from 'styles/variables';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import { connect } from 'react-redux';
import { Button, Box } from '@chameleoncreator/creator-ui';
import { InteractionContext } from '../../Layouts/ContainerLogical';
import { useLayoutEffect } from 'react';
import checkButtonColors from 'services/checkButtonColors';
import getAllInteractions from 'services/apiHelpers/getAllInteractions';
import isLastInteraction from 'services/apiHelpers/isLastInteraction';
import { onExit } from 'services/scorm/scormService';
import getBlockById from 'services/apiHelpers/getBlockById';
import getStore from 'services/getStore';
import isIE from 'services/isIE';
import getTopics from 'services/apiHelpers/getTopics';
import { useSelector } from 'react-redux';
import DButton from './DButton';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import LastPageMessage from 'components/Editor/EditorUtilities/UI/LastPageMessage';
import hasValidLocationUpdated from 'services/hasValidLocationUpdated';

const store = getStore();

const { lPink } = colors;

const ieCircleBtnPadding = 20;

const renderCount = {};

interface IEditable {
  isEditActive: boolean;
  children: any;
  lockDown: boolean;
  unlocked?: boolean;
  id: string;
  shape?: string;
  background?: string;
  foreground?: string;
  label?: string;
  color?: string;
  borderWidth?: string;
  borderColor?: string;
  localBorderColor?: boolean;
  buttonShape?: string;
  localShape?: boolean;
  borderRadius?: number | string;
  localBorderRadius?: boolean;
  localButtonOutline?: boolean;
  buttonOutline?: boolean;
  useLargeButton?: boolean;
  localUseLargeButton?: boolean;
  // buttonBorderRadius?: number | string;
  // localButtonBorderRadius?: boolean;
  buttonShadow?: boolean;
  localShadow?: boolean;
  font?: string;
  location?: string;
  style?: {};
  hasSetRemoveable?: boolean;
  removeable?: boolean;
  focusColor?: string;
  disableLastPageMessage?: boolean;
  enabled?: boolean;
}

const ContinueBtn = (props: IEditable) => {
  const {
    isEditActive,
    id,
    label,
    shape,
    // background,
    // color,
    borderWidth,
    // borderColor,
    // buttonShadow,
    // useLargeButton = false,
    font,
    location,
    unlocked,
    disableLastPageMessage,
    focusColor,
  } = props as any;

  // might not need this just yet
  // button is ' disabled ' by isLocked on interaction context
  let { enabled } = props;
  // so we can map it something else if need be

  const {
    buttonShape,
    buttonShadow,
    buttonOutline,
    useLargeButton,
    borderColor,
    buttonBorderRadius = 0,
  } = useSelector((state: any) => {
    // props.localShape props.localShadow
    // if this is set. means author has made a decision on the button props
    // we preference this setting true or false

    const {
      buttonShape,
      buttonShadow,
      buttonOutline,
      useLargeButton,
      buttonBorderColor,
      buttonBorderRadius,
    } = state.theme;

    return {
      buttonShape: props.localShape ? props.buttonShape : buttonShape,
      buttonShadow: props.localShadow ? props.buttonShadow : buttonShadow,
      buttonOutline: props.localButtonOutline
        ? props.buttonOutline
        : buttonOutline,
      useLargeButton: props.localUseLargeButton
        ? props.useLargeButton
        : useLargeButton,
      borderColor: props.localBorderColor
        ? props.borderColor
        : buttonBorderColor,
      buttonBorderRadius: props.localBorderRadius
        ? props.borderRadius
        : buttonBorderRadius,
    };
  });

  const { background, color } = checkButtonColors(props);

  const interactionContext = useContext(InteractionContext) as any;

  const exit =
    getAllInteractions().length > 1 &&
    // label.toLowerCase() === 'continue' &&
    location !== 'exit' &&
    isLastInteraction(interactionContext.id);

  useEffect(() => {
    // this is the hack to get this onto the legacy buttons
    // would want to set it from the factory but that would only work for newly created buttons
    //
    if (props.hasOwnProperty('removeable')) {
      const { hasSetRemoveable, removeable } = props;
      if (!hasSetRemoveable) {
        setBlockProps(getBlockById(id), { hasSetRemoveable: true, removeable });
      }
    }
  }, []);

  // error checking here against a potentially removed topic
  const hasValidLocation = hasValidLocationUpdated(location);
  // location === 'next'
  // ['next', 'exit'].includes(location)
  //   ? true
  //   : !!getTopics().find((t: any) => t.id === location);

  let buttonBlock = findByKeyVal_V2(
    interactionContext.id,
    'type',
    'Column'
  ) as any;

  const buttonCount =
    buttonBlock.meta &&
    buttonBlock.meta.subType === 'ButtonBlock' &&
    buttonBlock.children.length;

  return window.dev() ? (
    <Box
      id={`continue-btn-${id}`}
      p={2}
      px={3}
      flex={0}
      css={css`
        position: relative;
        box-shadow: ${isEditActive
          ? `0 0 0 1px ${lPink}`
          : `0 0 0 1px ${hasValidLocation ? 'lightGrey' : 'yellow'}`};
        transition: box-shadow 0.2s;
        cursor: pointer;
      `}
      onClick={e => {
        e.stopPropagation();
        if (isEditActive) {
          return;
        }
        setCurrentBlock({ id });
      }}
    >
      <DButton
        enabled={enabled}
        id={id}
        shape={buttonShape}
        background={background}
        foreground={color}
        // borderWidth={borderWidth}
        borderWidth={buttonOutline ? 1 : 0}
        // borderColor={borderColor}
        borderColor={background}
        buttonOutline={buttonOutline}
        useLargeButton={useLargeButton}
        borderRadius={buttonBorderRadius}
        buttonShadow={buttonShadow}
        font={font}
        location={location}
        focusColor={focusColor}
      >
        {/* {exit ? 'Exit' : label} */}
        {label}
      </DButton>
      {!isEditActive && <EditMarker />}

      {/* can only have the one button. else assumption is made author knows what they're up to */}
      {buttonCount === 1 && exit && !disableLastPageMessage && (
        <LastPageMessage />
      )}
    </Box>
  ) : (
    <DButton
      enabled={enabled}
      id={id}
      shape={buttonShape}
      // background={background}
      // foreground={color}

      // borderWidth={borderWidth}
      borderWidth={buttonOutline ? 1 : 0}
      // borderColor={borderColor}
      borderColor={background}
      borderRadius={buttonBorderRadius}
      font={font}
      location={hasValidLocation ? location : 'next'}
      focusColor={focusColor}
      unlocked={unlocked}
      buttonShadow={buttonShadow}
      {...{
        ...props,
        background,
        foreground: color,
        shape: buttonShape,
        borderRadius: buttonBorderRadius,
        buttonShadow,
        buttonOutline,
        useLargeButton,
      }}
    >
      {/* {exit ? 'Exit' : label} */}
      {label}
    </DButton>
  );
};

export default connect(
  ({ focusedNodeId }: { focusedNodeId: string | number }, props: any) => {
    return {
      isEditActive: focusedNodeId === props.id && props.id !== undefined,
      // [Math.random()]: '',
    };
  }
)(ContinueBtn);

// const Bx = (props: any) => {
//   // console.log(props.id, 'CONTINUE');

//   const {
//     buttonShape,
//     buttonShadow,
//     buttonOutline,
//     borderColor,
//     buttonBorderRadius = 0,
//   } = useSelector((state: any) => {
//     // props.localShape props.localShadow
//     // if this is set. means author has made a decision on the button props
//     // we preference this setting true or false

//     const {
//       buttonShape,
//       buttonShadow,
//       buttonOutline,
//       buttonBorderColor,
//       buttonBorderRadius,
//     } = state.theme;

//     return {
//       buttonShape: props.localShape ? props.buttonShape : buttonShape,
//       buttonShadow: props.localShadow ? props.buttonShadow : buttonShadow,
//       buttonOutline: props.localButtonOutline
//         ? props.buttonOutline
//         : buttonOutline,
//       borderColor: props.localBorderColor
//         ? props.borderColor
//         : buttonBorderColor,
//       buttonBorderRadius: props.localBorderRadius
//         ? props.borderRadius
//         : buttonBorderRadius,
//     };
//   });

//   const { background, color } = checkButtonColors(props);

//   const ctx = useContext(InteractionContext) as any;

//   const Bx_ = useMemo(() => {
//     if (!renderCount[props.id]) {
//       renderCount[props.id] = 0;
//     }

//     console.log(`continue > ${props.id} renders`, (renderCount[props.id] += 1));

//     //

//     const props_ = {
//       ...props,
//       shape: buttonShape,
//       buttonShadow,
//       buttonOutline,
//       borderColor,
//       buttonBorderRadius,
//       background,
//       foreground: color,
//     };

//     return (
//       <DButton {...props_}>
//         {/* {exit ? 'Exit' : label} */}
//         {props_.label}
//       </DButton>
//     );
//   }, []);

//   return Bx_;
// };

// export default Bx;
